export const useAuth = () => ({ isAuthenticated: true, accessToken: '' });
